/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Search_Where_ValueInputs */

const en_home_search_where_value = /** @type {(inputs: Home_Search_Where_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belgrade`)
};

/**
* | output |
* | --- |
* | "Belgrade" |
*
* @param {Home_Search_Where_ValueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_search_where_value = /** @type {((inputs?: Home_Search_Where_ValueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Search_Where_ValueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_search_where_value(inputs)
});